export const environment = {
  production: true,

  authApiUrl: 'https://api.medigencehealth.io/v1',
  apiUrl: 'https://api.medigencehealth.io/v1/iam',
  spApiUrl: 'https://api.medigencehealth.io/v1/scheduler',
  ppApiUrl: 'https://api.medigencehealth.io/v1/provider',
  cpApiUrl: 'https://api.medigencehealth.io/v1/coder',
  iamUrl: 'https://iam.medigencehealth.io/Iamportal',
  loginUrl: 'https://medigencehealth.io/app-launcher.html',
  logoutUrl: 'https://medigencehealth.io/',

  // Sentry configuration
  sentryUrl: 'https://460528a646b88929ea643ec3663cfb02@o4507310805352448.ingest.us.sentry.io/4507310995865600',
  sentryTracePropagationTargets: [/^https:\/\/api\.medigencehealth\.io/],
  sentryReplaysSessionSampleRate: 0.1,
  sentryReplaysOnErrorSampleRate: 1.0,
  sentryTracesSampleRate: 0.3,
  sentryEnvironment: 'Production',
};
